import React, { Component } from "react";

import {
  Drawer,
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Upload,
  Icon,
  message,
} from "antd";

import axiosAtendimento from "../../../constants/axiosAtendimento";

const Option = Select.Option;
const { TextArea } = Input;
const Dragger = Upload.Dragger;

const initialState = {
  ticket: {
    IdErro: "",
    IdCategoria: null,
    Assunto: null,
    NomeResponsavel: null,
    TelefoneResponsavel: null,
    Descricao: null,
    Arquivos: [],
  },
  fileList: [],
  uploading: false,
  disabledButton: true,
  sendingTicket: false,
  tokenApiTicket: null
};

let categorias = [];

class Ticket extends Component {
  state = { ...initialState };

  async carregaCategorias() {
    await axiosAtendimento
      .get("ticket/categorias")
      .then((response) => {
        if (response.status === 200) {
          categorias = response.data.conteudo;
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status !== 403) {
          //message.error("Erro ao carregar as categorias");
        }
      });
  }
  async componentDidMount() {
    await this.carregaCategorias();
  }

  componentDidUpdate(prevProps, prevState) {
    const { IdCategoria, Assunto, NomeResponsavel, TelefoneResponsavel, Descricao } = this.state.ticket;
    
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.props.form.resetFields();
      this.setState(initialState);
    }

    if (prevState.ticket !== this.state.ticket) {
      if (IdCategoria && Assunto && NomeResponsavel && TelefoneResponsavel && Descricao) {
        this.setState({ disabledButton: false });
      } else {
        this.setState({ disabledButton: true });
      }
    }
  }

  handleChange = (e, field) => {
    const value = field ? e : e.target.value,
      name = field ? field : e.target.name;

    this.setState((prevState) => ({
      ticket: {
        ...prevState.ticket,
        [name]: value,
      },
    }));
  };

  sendTicket = () => {
    const { ticket, uploading } = this.state;
    let data = { ticket: { ...ticket } };
    
    const formData = new FormData();
    formData.append("IdCategoria", data.ticket.IdCategoria);
    formData.append("IdErro", data.ticket.IdErro);
    formData.append("Assunto", data.ticket.Assunto);
    formData.append("NomeResponsavel", data.ticket.NomeResponsavel);
    formData.append("TelefoneResponsavel", data.ticket.TelefoneResponsavel);
    formData.append("Descricao", data.ticket.Descricao);
    this.state.fileList.forEach(file => {
      formData.append('Arquivos', file);
    });

    if (!uploading) {
      this.props.form.validateFields((err) => {
        if (!err) {
          this.setState({ sendingTicket: true });
          axiosAtendimento
            .post("/ticket/cadastrar", formData)
            .then((response) => {
              
              if (response.data.sucesso === true) {
                message.success(`Ticket salvo com sucesso (${response.data.conteudo})`);
                this.props.form.resetFields();
                this.setState({ ...initialState });
                /* Fecha o Drawer quando o ticket é aberto com sucesso */
                this.props.onClose();
              } else {
                message.error(response.data.conteudo);
              }

              this.setState({ sendingTicket: false });
            })
            .catch((error) => {
              if (error && error.response && error.response.status !== 403) {
                message.error("Erro ao enviar o ticket");
              }

              this.setState({ sendingTicket: false });
            });
        }
      });
    } else {
      message.info("Aguarde o termino do upload dos arquivos!");
    }
  };

  render() {
    const { visible, onClose } = this.props,
      { fileList, uploading, disabledButton, sendingTicket } = this.state,
      { getFieldDecorator } = this.props.form;

    const propsUpload = {
      name: "Arquivos",
      multiple: false,
      accept: '.zip, .rar, .7z',
      data: {},
      customRequest: () => { },
      disabled: false,
      withCredentials: true,
      onChange: (elem) => {
        // Verifica se todos os arquivos no evento de upload estão com o status 'done'
        this.setState({
          uploading:
            false,
        });
      },
      onRemove: (file) => {
        // Ao remover um arquivo do Upload, remove da lista de arquivos
        this.setState((prevState) => ({
          ticket: {
            ...this.state.ticket,
            Arquivos: prevState.ticket.Arquivos.filter(
              (el) => el.Nome !== file.name
            ),
          },
          fileList: prevState.fileList.filter((el) => el.name !== file.name),
        }));
        return true;
      },
      beforeUpload: (file) => {
        const format = file.name.split(".").pop();
        if (format.toUpperCase() === "ZIP" || format.toUpperCase() === "RAR") {
          this.setState((prevState) => ({
            ticket: {
              ...this.state.ticket,
              Arquivos: [...prevState.ticket.Arquivos, { Nome: file.name }],
            },
            fileList: [file],
          }));
          return true;
        } else {
          message.error(
            `Não foi possível efetuar a operação! Para anexar um arquivo no ticket, este deve estar em formato .rar ou .zip, o nome não pode conter caracteres especiais e nem estar muito extenso.`
          );
          return false;
        }
      },
      fileList,
    };

    return (
      <Drawer
        className="ant-drawer--custom"
        title="ABERTURA DE TICKET PARA SUPORTE"
        placement="right"
        width={650}
        onClose={onClose}
        visible={visible}
      >
        <Form
          layout="vertical"
          hideRequiredMark
          style={{ paddingBottom: "40px" }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Categoria">
                {getFieldDecorator("categoria", {
                  initialValue: null,
                  rules: [
                    {
                      required: true,
                      message: "O campo de categoria é obrigatório",
                    },
                  ],
                })(
                  <Select
                    className="ant-select--custom"
                    name="categoria"
                    onChange={(e) => this.handleChange(e, "IdCategoria")}
                  >
                    <Option value={null}>Todos</Option>
                    {categorias && categorias.map((item) => {
                      return (
                        <Option key={item.idCategoria} value={item.idCategoria}>
                          {item.nome}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Assunto">
                {getFieldDecorator("assunto", {
                  rules: [
                    {
                      required: true,
                      message: "O campo de assunto é obrigatório",
                    },
                  ],
                })(
                  <Input
                    className="form-control"
                    name="Assunto"
                    onChange={this.handleChange}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Seu nome">
                {getFieldDecorator("nome", {
                  rules: [
                    {
                      required: true,
                      message: "O campo de nome é obrigatório",
                    },
                  ],
                })(
                  <Input
                    className="form-control"
                    name="NomeResponsavel"
                    onChange={this.handleChange}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Telefone">
                {getFieldDecorator("telefone", {
                  rules: [
                    {
                      required: true,
                      message: "O campo de telefone é obrigatório",
                    },
                    {
                      validator: (rule, value, callback) => {
                        if (value) {
                          if (value.match(/^\d+$/) === null) {
                            callback("O telefone deve conter somente números.");
                          } else if (value.length <= 9) {
                            callback("O telefone deve conter o DDD.");
                          }
                        }
                        callback();
                      },
                    },
                  ],
                })(
                  <Input
                    className="form-control"
                    name="TelefoneResponsavel"
                    onChange={this.handleChange}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Descrição">
                {getFieldDecorator("descricao", {
                  rules: [
                    {
                      required: true,
                      message: "O campo de descrição é obrigatório",
                    },
                  ],
                })(
                  <TextArea
                    className="form-control"
                    name="Descricao"
                    rows={4}
                    onChange={this.handleChange}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Dragger {...propsUpload}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">
                Clique ou arraste o(s) anexo(s) para esta área
              </p>
              <p className="ant-upload-hint">
                Os anexos devem estar em formato .RAR ou .ZIP
              </p>
            </Dragger>
          </Row>
        </Form>
        <div className="ant-drawer__footer" style={{ width: 650 }}>
          <Button
            onClick={this.sendTicket}
            type="primary"
            disabled={uploading || disabledButton}
            loading={sendingTicket}
          >
            Enviar
          </Button>
        </div>
      </Drawer>
    );
  }
}

export default Form.create({ name: "ticket" })(Ticket);
